import {defineMessages} from 'react-intl';

const messages = defineMessages({
  reportIssue: {
    id: 'reportIssue',
    defaultMessage: 'Report issue'
  },
  issueReported: {
    id: 'issueReported',
    defaultMessage: 'Issue reported'
  }
});

export default messages;
